import { render } from "./WelcomePanel.vue?vue&type=template&id=3197486e&scoped=true"
import script from "./WelcomePanel.vue?vue&type=script&lang=js"
export * from "./WelcomePanel.vue?vue&type=script&lang=js"

import "./WelcomePanel.vue?vue&type=style&index=0&id=3197486e&scoped=true&lang=css"
import "./WelcomePanel.vue?vue&type=style&index=1&id=3197486e&lang=css"

import exportComponent from "/Users/dgorski/tenball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3197486e"]])

export default __exports__